<script lang="ts">
  interface Props {
    originalText: string
    errorClass: 'error' | 'warning'
    isKeptOriginal: boolean
    onClick: (e: MouseEvent) => void
  }
  
  let { originalText, errorClass, isKeptOriginal, onClick }: Props = $props()
</script>

<button
  class="error-original {errorClass}"
  class:kept-original={isKeptOriginal}
  onclick={onClick}
  title={isKeptOriginal ? '원본 유지 해제' : '원본 유지'}
>
  {#if isKeptOriginal}
    <span class="kept-badge">원본 유지</span>
  {/if}
  {originalText}
</button>

<style>
  /* Original text button */
  .error-original {
    font-size: 12px;
    font-weight: normal;
    padding: 2px 6px;
    border-radius: 4px;
    transition: all 0.15s ease;
    display: inline-block;
    border: 1px solid transparent;
    flex-shrink: 0;
    cursor: pointer;
    background: transparent;
    line-height: 1.3;
    font-family: inherit;
  }
  
  .error-original.error {
    color: var(--error);
    background: rgba(239, 68, 68, 0.08);
    border-color: rgba(239, 68, 68, 0.2);
  }
  
  .error-original.error:hover {
    background: rgba(239, 68, 68, 0.15);
  }
  
  /* Warning style for kept original */
  .error-original.warning {
    color: var(--warning);
    background: rgba(245, 158, 11, 0.08);
    border-color: rgba(245, 158, 11, 0.2);
  }

  .error-original.warning:hover {
    background: rgba(245, 158, 11, 0.15);
  }

  /* Kept original badge */
  .kept-badge {
    display: inline-block;
    margin-right: 6px;
    padding: 1px 4px;
    font-size: 10px;
    font-weight: 600;
    color: var(--success, #10b981);
    background: rgba(16, 185, 129, 0.1);
    border: 1px solid rgba(16, 185, 129, 0.2);
    border-radius: 3px;
    vertical-align: middle;
    white-space: nowrap;
  }

  .error-original.kept-original {
    font-weight: 500;
  }
  
  /* Mobile optimizations */
  @media (max-width: 768px) {
    .error-original {
      font-size: 15px;
      padding: 4px 8px;
    }
  }
  
  /* Dark mode support - Match editor highlighting */
  @media (prefers-color-scheme: dark) {
    :root:not(.light-theme) .error-original.error {
      background: rgba(255, 255, 255, 0.95);
      color: #0a0a0a;
      border-color: rgba(255, 255, 255, 0.5);
      box-shadow: none;
    }
    
    :root:not(.light-theme) .error-original.error:hover {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.5);
    }
    
    :root:not(.light-theme) .error-original.warning {
      background: rgba(255, 200, 100, 0.95);
      color: #0a0a0a;
      border-color: rgba(255, 200, 100, 0.5);
      box-shadow: none;
    }
    
    :root:not(.light-theme) .error-original.warning:hover {
      background: rgba(255, 200, 100, 1);
      box-shadow: 0 0 0 1px rgba(255, 200, 100, 0.5);
    }
  }
  
  /* Also support explicit dark theme class */
  :global(.dark-theme) .error-original.error {
    background: rgba(255, 255, 255, 0.95);
    color: #0a0a0a;
    border-color: rgba(255, 255, 255, 0.5);
    box-shadow: none;
  }
  
  :global(.dark-theme) .error-original.error:hover {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.5);
  }
  
  :global(.dark-theme) .error-original.warning {
    background: rgba(255, 200, 100, 0.95);
    color: #0a0a0a;
    border-color: rgba(255, 200, 100, 0.5);
    box-shadow: none;
  }
  
  :global(.dark-theme) .error-original.warning:hover {
    background: rgba(255, 200, 100, 1);
    box-shadow: 0 0 0 1px rgba(255, 200, 100, 0.5);
  }
  
  /* Reduced motion */
  @media (prefers-reduced-motion: reduce) {
    .error-original {
      transition: none;
    }
  }
</style>